export default "__VITE_ASSET__1394c64d__"